import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModalEmptyAddressesService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpenSubject.asObservable();

  constructor() { }

  toggleModal(value?: boolean): void {
    const newValue = value !== undefined ? value : !this.isOpenSubject.value;
    this.isOpenSubject.next(newValue);
  }

  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }
}